import React, { useContext } from 'react';

export const ConfigContext = React.createContext<{
  googleClientId?: string;
  host?: string;
}>({
  googleClientId: undefined,
  host: undefined,
});

export function useConfig() {
  return useContext(ConfigContext);
}
